import React, { Component } from 'react';
import { Trans } from 'react-i18next';

class PageNotFound extends Component {
    componentDidMount() {
        document.title = "Page Not Found - FleetXPress"
    }

    render() {
        return (
            <div className = "errorpage-wrapper">
                <img src = "/images/404.png" />
                <h1 className = "mt-24 mb-24"><Trans>The page you're looking for doesn't exist.</Trans></h1>
                <a href="home" className = "button primary"><Trans>Go back to home page</Trans></a>
            </div>
        );
    }
}

export default PageNotFound;